module.exports = __webpack_public_path__ + "43131e14f6e21bdb395dd021229f26b2.png";